// Review Types
export interface Review {
  reviewId: string;
  productSku: string;
  productName: string;
  customerNumber: string;
  userName: string;
  rating: number;
  title: string;
  content: string;
  status: ReviewStatus;
  moderationStatus: ModerationStatus;
  flags: ReviewFlag[];
  createdAt: string;
  updatedAt: string;
  moderatedAt?: string;
  moderatedBy?: string;
  moderatorNotes?: string;
}

export enum ReviewStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum ModerationStatus {
  Clean = 'Clean',
  PreFlagged = 'PreFlagged',
  Flagged = 'Flagged',
}

export interface ReviewFlag {
  type: FlagType;
  confidence: number;
  details?: string;
}

export enum FlagType {
  Profanity = 'Profanity',
  Spam = 'Spam',
  OffTopic = 'OffTopic',
  PersonalInfo = 'PersonalInfo',
  Harassment = 'Harassment',
}

// API Types
export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface ReviewFilters {
  status?: ReviewStatus[];
  moderationStatus?: ModerationStatus[];
  flagTypes?: FlagType[];
  rating?: number[];
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}

export interface ReviewListParams extends ReviewFilters {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface ModerateReviewRequest {
  reviewId: string;
  action: 'approve' | 'reject';
  notes?: string;
}

export interface BulkModerateRequest {
  reviewIds: string[];
  action: 'approve' | 'reject';
  notes?: string;
}

export interface BulkModerateResponse {
  successful: string[];
  failed: Array<{ reviewId: string; error: string }>;
}

// Auth Types
export interface User {
  id: string;
  email: string;
  name: string;
  roles: string[];
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: () => Promise<string>;
}

// UI Types
export interface DataTableColumn<T> {
  id: string;
  header: string;
  accessorKey?: keyof T;
  cell?: (row: T) => React.ReactNode;
  enableSorting?: boolean;
  enableFiltering?: boolean;
}

export interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}
